import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateCodeBrowserColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

import TemplateFeatureGateTooltip from "./FeatureGate/Tooltip";
import { TemplateActions } from "./FeatureGate/types";

type TemplatesEmptyProps = {
  hasNoResults?: boolean;
  onCreate: () => void;
};

const TemplatesWorkbenchEmpty = ({ hasNoResults, onCreate }: TemplatesEmptyProps) => {
  return (
    <>
      {hasNoResults && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoResults && (
        <EmptyState
          title="You don’t have any templates yet"
          icon={EmptystateCodeBrowserColored}
          caption={`Templates are "stack factories". They can be used by your teammates to quickly provision
          a stack by filling out a simple form.`}
        >
          <Box gap="medium">
            <DocumentationButton to={getDocsUrl("/concepts/template")} label="Documentation" />
            <TemplateFeatureGateTooltip
              action={TemplateActions.CreateTemplate}
              on={({ isDisabled, ...props }) => (
                <Button {...props} variant="primary" onPress={onCreate} disabled={isDisabled}>
                  Create template
                </Button>
              )}
            />
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default TemplatesWorkbenchEmpty;
